<mat-card class="ele-place" fxLayout="column" fxLayoutAlign="start stretch" style="width: 100%; height: 100%; box-sizing: border-box;">
    <mat-card-content fxLayout="column" fxFlex="100%">
        <div fxLayout="row" fxFlex="100%" fxLayoutAlign="space-between baseline">

            <div fxLayout="column" fxFlex="100%">

                <div *ngFor="let item of [
        { key: 'totalSessionPlayed', icon: 'timer', color: 'blue', label: 'Total Session' },
        { key: 'averageDuration', icon: 'check_circle', color: 'green', label: 'Average Duration' },
         { key: 'totalDuration', icon: 'check_circle', color: 'green', label: 'Total Duration' }
      ]" fxLayout="row" fxLayoutAlign="start center" fxFlex="100%"
                    style="padding: 5px 0; border-bottom: 1px solid #eee;">
                    <div style="height: 40px;">&nbsp;</div>

                    <!-- Icon -->
                    <div *ngIf="item.icon !== 'custom'" fxLayoutAlign="center center"
                        style="width: 40px; height: 40px; border-radius: 50%;" [ngStyle]="{
           'background-color':
             item.color === 'green' ? '#e8f5e9' :
             item.color === 'red' ? '#fdecea' : '#e3f2fd'
         }">
                        <mat-icon [ngStyle]="{
          'color':
            item.color === 'green' ? '#2e7d32' :
            item.color === 'red' ? '#c62828' : '#1565c0'
        }">
                            {{ item.icon }}
                        </mat-icon>
                    </div>

                    <div *ngIf="item.icon == 'custom'" fxLayoutAlign="center center"
                        style="border-radius: 50%;">
                        <img src="assets/img/prof.png" alt="Startagem" height="25px" width="25px">
                    </div>

                    <!-- Text -->
                    <div fxLayout="column" style="margin-left: 12px;">
                        <div style="font-size: 20px; font-weight: 600;">
                            {{ dataList[item.key] }}{{ item.suffix || '' }}
                        </div>
                        <div style="font-size: 13px; color: #666;">
                            {{ item.label }}
                        </div>
                    </div>
                    <div style="height: 40px;">&nbsp;</div>

                </div>

            </div>

        </div>
    </mat-card-content>
</mat-card>